import {Component, OnInit} from '@angular/core';
import {BaseService} from '~/app/core/common/services/base.service';
import {ApiService} from '~/app/core/common/services/api.service';
import {KeycloakHelper} from '~/app/shared/helpers/keycloak-helper';

@Component({
    selector: 'app-no-stores-dialog',
    templateUrl: './no-stores-dialog.component.html',
    styleUrls: ['./no-stores-dialog.component.scss']
})
export class NoStoresDialogComponent implements OnInit {
    splunkId: any;
    userId: string;

    constructor(public baseService: BaseService,
                public apiService: ApiService,
                public keycloakHelper: KeycloakHelper) {
    }

    ngOnInit() {
        this.userId = this.keycloakHelper.getUsername() !== null ? this.keycloakHelper.getUsername() : 'N/A';
        let splunkId = Math.random().toString(36).substr(2, 3);
        splunkId += '.';
        splunkId += Math.random().toString(36).substr(2, 3);
        console.log(splunkId);
        this.splunkId = splunkId.toUpperCase();

        const splunkMsg: JSON = <JSON><unknown>{
            'splid': splunkId.toUpperCase(),
            'message': 'No Stores for UserId: ' + this.userId
        };
        const json = JSON.stringify(splunkMsg);
        this.baseService.postHttpJson(
            'ngOnInit',
            'no-stores-dialog-component',
            this.apiService.splunkErrorURL,
            json)
            .toPromise()
            .then(r => console.log(r))
            .catch(e => console.error(e));
    }
}
